/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.ready(() => App.messages.init())

App.messages = {
  scroll_container_selector: ".js-content-main",

  init() {
    // console.log(" ---- in App.messages.init")
    App.messages.init_forever_scroll()

    App.unsubscribe("account.messages.updated", App.messages.updated)
    App.subscribe("account.messages.updated", App.messages.updated)

    this.scroll_to_message_param()
    this.show_notifications_count()

    return $(document)
      .off("click", ".js-msg-stats-btn", App.messages.stats_clicked)
      .on("click", ".js-msg-stats-btn", App.messages.stats_clicked)
  },

  init_forever_scroll() {
    $(App.messages.scroll_container_selector).off('scroll')

    if ($('.js-msg-bucket').length > 0) {
      if (App.is_phone()) {
        return $(document).on("scroll", App.messages.phone_scrolled)
      } else {
        return $(App.messages.scroll_container_selector).on("scroll", App.messages.desktop_scrolled)
      }
    }
  },

  on_messages_view() {
    return /\/messages$/i.test(location.pathname)
  },

  desktop_scrolled(evt) {
    const max_scroll = $(".js-content-inner").height()
    const cur_scroll = $(App.messages.scroll_container_selector).scrollTop()

    // are we at the bottom?
    if ((cur_scroll >= (max_scroll - $(window).height())) &&
      !$('.js-messages-loaded').is(':visible') &&
      !$('.js-messages-loading').is(':visible')) {

      $('.js-messages-loading').show()

      const current_page = parseInt($('.js-msg-bucket').last().attr('data-page'), 10) || 1
      const next_page = current_page + 1
      // load next set of messages & notices
      return App.messages.load_next(next_page)
    }
  },

  phone_scrolled(evt) {
    const window_height = $(window).height()
    const max_scroll = $(document).height() - window_height
    const cur_scroll = $(document).scrollTop()

    // console.log "\n\nwindow_height: ", window_height
    // console.log "cur_scroll: ", cur_scroll
    // console.log "max_scroll: ", max_scroll

    // are we at the bottom?
    if ((cur_scroll >= max_scroll) &&
      !$('.js-messages-loaded').is(':visible') &&
      !$('.js-messages-loading').is(':visible')) {

      $('.js-messages-loading').show()

      const current_page = parseInt($('.js-msg-bucket').last().attr('data-page'), 10) || 1
      const next_page = current_page + 1
      // load next set of messages & notices
      return App.messages.load_next(next_page)
    }
  },

  load_next(page) {
    // Honor search criteria
    const query = $('.js-search-filter>input')
    return $.ajax({
      url: window.location.href,
      method: 'GET',
      data: { page, q: query.val() },
      success() {
        return $('.js-messages-loading').hide()
      }
    })
  },

  // evt.detail: { message_id: int, group_ids: [int,...], sent: bool }
  updated(evt) {
    // console.log("App.messages.updated, ", evt)
    // console.log("App.messages.requesting_index: ", App.messages.requesting_index)
    // Are we already in the middle of requesting the current index data?
    if (App.messages.requesting_index) { return }

    // only run on the messages view
    if (!App.messages.on_messages_view()) { return }

    const data = evt.detail
    const current_group_id = App.groups.current_id()
    const current_is_pending = /scheduled=1/.test(location.search)
    const sent_state_matches = current_is_pending !== data.sent

    // Does this message pertain to our currently viewed group?
    // Always update if we're on the "All" stream
    if (((data.group_ids.includes(current_group_id)) || App.groups.is_all_group()) && sent_state_matches) {
      App.messages.requesting_index = true
      const scheduled = current_is_pending ? "?scheduled=1" : ""
      App.messages.save_stats_toggle_state()
      return $.get(`/groups/${current_group_id}/messages${scheduled}`, function () {
        App.messages.restore_stats_toggle_state()
        return App.messages.requesting_index = false
      })
    }
  },

  scroll_to_message_param() {
    // console.log "in scroll_to_message_param"
    let matches
    if ((matches = /msg-(\d+)/.exec(location.hash.toString()))) {
      // console.log "looking for ", "#message-#{matches[1]}"
      const msg = $(`#message-${matches[1]}`)
      $(".js-content-main").scrollTo(msg, msg, { gap: { y: -150 } })

      msg.closest(".js-msg-bucket").addClass("highlighted")
      return window.setTimeout((() => msg.closest(".js-msg-bucket").removeClass("highlighted")), 5000)
    }
  },

  stats_clicked(evt) {
    return $(this).closest(".js-msg").toggleClass("stats-open")
  },

  save_stats_toggle_state() {
    const ids = $(".js-msg.stats-open").map(function () {
      return $(this).data("id")
    })
    return localStorage.stats_open_ids = JSON.stringify(ids.toArray())
  },

  restore_stats_toggle_state() {
    let ids
    if ((ids = localStorage.stats_open_ids)) {
      for (var id of JSON.parse(ids)) {
        $(`.js-msg[data-id='${id}']`).addClass("stats-open")
      }
      return delete localStorage.stats_open_ids
    }
  },

  show_notifications_count() {
    let $el
    if (($el = $('.js-new-notifications-badge')).length) {
      if (parseFloat($el.text()) > 0) {
        return $el.addClass('active')
      }
    }
  }
}
